angular.module('ihestiaRestServicesBase')
  .factory('ihestiaRestVehicleDictionaryFuelTypesSvc', ['ihestiaRestAbstractVehicleDictionariesSvc',
    function(ihestiaRestAbstractVehicleDictionariesSvc) {

      var RestDictionaryVehicleSvc = function() {
        ihestiaRestAbstractVehicleDictionariesSvc.apply(this, arguments);

        this.id = 'fuelTypes';

      };
      return new RestDictionaryVehicleSvc();
    }
  ]);